export default (() => {
    // Set CSRF dynamically because of Cloudflare caching. 
    const response = fetch('/forms/refresh-token', {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "no-cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
      },
      body: undefined
    });
    response.then((data) => data.json()).then((csrfData) => {
        window.csrfTokenName = csrfData.csrf.param;
        window.csrfTokenValue = csrfData.csrf.token;
    });
})()